<template>
    <div class="employees">
        <div class="toggle-bar">
            <span class="toggle-option" :class="{ active: showActive }" @click="showActive = true">
                Aktive i {{ providerName }} ({{ activeEmployees.length }})
            </span>
            <span class="toggle-option" :class="{ active: !showActive }" @click="showActive = false">
                Inaktive i {{ providerName }} ({{ inactiveEmployees.length }})
            </span>
        </div>
        <div class="employee" v-for="employee in filteredEmployees" :key="employee.uuid">
            <div class="name">
                {{ employee.full_name }}
                <span class="employee-id">#{{ employee.external_id }}</span>
            </div>
            <div class="hours">
                Timer/uge:
                <input type="number" v-model="employee.weekly_hours_working" @keydown="showUpdateButton = employee.uuid" @change="showUpdateButton = employee.uuid" />
                <button v-show="showUpdateButton === employee.uuid" @click="updateEmployee(employee)">
                    &nbsp;
                    Opdater
                </button>
            </div>
            <div class="working-responsible">
                <div class="mb-2">
                    <input type="checkbox" v-model="employee.employed_field" @change="updateEmployee(employee)" style="transform:scale(1.2);" />
                    Ansættelse aktiv
                </div>
                <div class="mb-2">
                    <input type="checkbox" v-model="employee.working_field" @change="updateEmployee(employee)" style="transform:scale(1.2);" />
                    Udfører arbejde hos kunder
                </div>
                <div>
                    <input type="checkbox" v-model="employee.responsible_field" @change="updateEmployee(employee)" style="transform:scale(1.2);" />
                    Er opgaveansvarlig
                </div>
            </div>
            <div class="working-field-name">
                <b style="display:block;margin-bottom:4px;">Medarbejdertype</b>
                <select v-model="employee.working_field_name" @change="updateEmployee(employee, $event)">
                    <option :value="employeeType" v-for="employeeType in employeeTypes" :key="employeeType">
                        {{ employeeType }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .placeholder {
        margin-bottom: $margin--main;
    }

    .title {
        margin-bottom: $margin--main / 2;
    }

    .toggle-bar {
        display: flex;
        gap: 8px;
        margin-bottom: $margin--main / 2;

        .toggle-option {
            padding: 6px 14px;
            border-radius: $borderradius--main;
            cursor: pointer;
            font-weight: 600;
            font-size: $fontsize--small * 1.1;
            background: rgba(0, 0, 0, 0.05);

            &.active {
                background: $color--dark;
                color: #fff;
            }
        }
    }

    .row {
        
        .inside {
            padding: $padding--small;
            background: rgba(0, 0, 0, 0.05);
            border-radius: $borderradius--main;
            font-size: $fontsize--small * 1.1;
            font-weight: 600;
            height: 100%;

            .small {
                margin-top: $margin--main / 2;
                font-size: $fontsize--small * 1.1;
                font-weight: normal;
            }
        }
    }

    .employees {

        .employee {
            background: $color--white;
            padding: ($padding--main) $padding--main;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: $borderradius--main;
            margin-bottom: $margin--small;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);

            .name {
                flex: 0 0 25%;
                font-weight: 600;

                .employee-id {
                    font-weight: normal;
                    font-size: $fontsize--small;
                    color: $color--grey;
                    margin-left: 4px;
                }
            }

            .hours {
                flex: 0 0 20%;
                display: flex;
                align-items: center;

                input {
                    margin-left: $margin--small;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    width: 50px;
                    border-radius: $borderradius--main;
                    padding-left: 10px;
                }
            }

            .working {
                flex: 0 0 20%;
                display: flex;
                align-items: center;

                input {
                    margin-right: $margin--small;
                }
            }

            .working-field-name {
                flex: 0 0 20%;

                select {
                    padding: 4px 10px;
                    border: 1px solid rgba(0,0,0,0.15);
                    border-radius: 3px;
                    cursor: pointer;
                    box-sizing: border-box;
                }
            }
        }
    }

</style>

<script>
import * as employeeService from '@/services/employeeService'
import * as companyService from '@/services/companyService'

export default {
    data () {
        return {
            employeeTypes: [
                'Svend, funktionær',
                'Svend, timelønnet',
                'Lærling'
            ],
            showActive: true,
            showUpdateButton: null,
            employees: null,
            employeeCalc: ''
        }
    },
    computed: {
        activeEmployees () {
            if (!this.employees) return []
            return this.employees.filter(e => e.status)
        },
        inactiveEmployees () {
            if (!this.employees) return []
            return this.employees.filter(e => !e.status)
        },
        filteredEmployees () {
            return this.showActive ? this.activeEmployees : this.inactiveEmployees
        },
        providerName () {
            const slug = this.$auth.user().company.api_provider.slug
            return slug === 'minuba' ? 'Minuba' : 'Ordrestyring'
        }
    },
    created () {
        this.getEmployees()
        // this.getEmployeeCalc()
    },
    methods: {
        getEmployeeCalc () {
            companyService.employeeCalc({}, (response) => {
                this.employeeCalc = response.data
            }, (err) => {
                console.log(err)
            })
        },
        selectEmployeeCalc (type) {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.')
                return
            }
            let body = {
                employeeCalc: type
            }
            companyService.updateEmployeeCalc(body, (response) => {
                console.log(response)
                this.getEmployeeCalc()
                this.$toastr('success', 'Medarbejder indtjening indstillingen blev opdateret', 'Sådan!')
            }, (err) => {
                console.log(err)
            })
        },
        getEmployees () {
            employeeService.findAll({}, (response) => {
                this.employees = response.data
            }, (err) => {
                console.log(err)
            })
        },
        updateEmployee (employee) {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.')
                return
            }
            this.showUpdateButton = null
            let body = {
                employed_field: employee.employed_field,
                working_field: employee.working_field,
                responsible_field: employee.responsible_field,
                weekly_hours_working: employee.weekly_hours_working,
                working_field_name: employee.working_field_name ? employee.working_field_name : ''
            }
            employeeService.update(employee.id, body, (response) => {
                this.$toastr('success', 'Medarbejderen blev opdateret', 'Sådan!')
            }, (err) => {
                this.$toastr('error', 'Der skete en fejl ved opdatering af medarbejderen', 'Hov!')
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// employees.vue?4dcdbbf1